import React from 'react';
import Layout from './Layout';
import { Link, StaticRouter } from 'react-router-dom';
import { renderToStaticMarkup } from 'react-dom/server';
import { Helmet } from 'react-helmet';

const WHATSAPP_DUDAS = 'https://wa.me/5217712438160?text=' + encodeURIComponent('Hola, tengo una pregunta sobre el servicio de internet.');

// Textos revisados por el área legal: no editar sin su visto bueno.
const CATEGORIAS = [
    {
        id: 'pagos',
        titulo: 'Pagos y cargos',
        icono: 'fas fa-wallet',
        preguntas: [
            {
                pregunta: '¿Dónde puedo pagar mi servicio?',
                respuesta: <>¡Pagar tu servicio es muy sencillo! Puedes pagar en efectivo directamente en nuestras oficinas o por medio de transferencia, depósito bancario o en establecimientos (Farmacias Guadalajara) para más información consulta la pestaña de “Formas de Pago”.</>,
            },
            {
                pregunta: '¿Cuál es la fecha límite para pagar mi servicio?',
                respuesta: <>La fecha límite para pagar tu servicio es el 5° día de cada mes, una vez pasada esa fecha Itmex podrá suspender el servicio y en caso de que quieras seguir utilizando el servicio deberás pagar el costo de correspondiente de reconexión.</>,
            },
            {
                pregunta: '¿Qué es el cargo por reconexión?',
                respuesta: <>Es el cargo que Itmex cobrará en caso de que desee seguir utilizando servicio posteriormente a haber sido suspendido. El costo de reconexión es de $30.00.</>,
            },
        ],
    },
    {
        id: 'contratacion',
        titulo: 'Contratación',
        icono: 'fas fa-file-signature',
        preguntas: [
            {
                pregunta: '¿Existe un plazo mínimo de contratación del servicio?',
                respuesta: <>El usuario puede contratar el servicio de forma indefinida o sujetarse a un plazo forzoso de 12 meses. En este último caso el usuario puede obtener varios beneficios, para más información revisa nuestro apartado de <Link to="/promociones">promociones</Link>.</>,
            },
            {
                pregunta: 'Ya cuento con servicio de internet, pero quiero cambiarme a Itmex.',
                respuesta: <>Si actualmente cuentas con algún proveedor de internet y quieres cambiar el servicio de Itmex, ¡no hay problema! Te recomendaremos diferentes paquetes que pueden adaptarse a tus necesidades.</>,
            },
            {
                pregunta: '¿Cuál es la zona de cobertura?',
                respuesta: <>Puedes revisar las zonas que integran la cobertura de Itmex <Link to="/cobertura">aquí</Link>. De igual forma, puede comunicarte con nosotros para preguntar sobre la disponibilidad del servicio en determinada zona domicilio.</>,
            },
            {
                pregunta: '¿Puedo cambiar mi plan de internet inalámbrico a fibra óptica?',
                respuesta: <>Si, sin embargo, se revisará la factibilidad técnica para realizar el cambio. En caso de que el cambio sea técnicamente posible, te apoyaremos con el cambio y te explicaremos los beneficio que obtendrás y nuevo costo que pagarás.</>,
            },
        ],
    },
    {
        id: 'soporte',
        titulo: 'Servicio y soporte',
        icono: 'fas fa-headset',
        preguntas: [
            {
                pregunta: '¿Por qué debo tener encendidos los equipo todo el tiempo?',
                respuesta: <>Para que haya un mejor monitoreo en tu servicio y para que nuestros técnicos puedan dar mantenimiento a tus equipos de manera remota sin costo alguno, con el fin de mejorar tu experiencia en internet.</>,
            },
            {
                pregunta: '¿Qué es la asistencia a domicilio?',
                respuesta: <>Es el apoyo técnico ante cualquier falla o desperfecto derivado de causas imputables al usuario. El costo de la visita técnica es de $100.00.</>,
            },
            {
                pregunta: '¿Qué hago si tengo problemas con mi conexión de fibra óptica?',
                respuesta: <>En <b>Red Itmex</b> siempre estamos listos para ayudarte. Si tienes algún problema, no dudes en <Link to="/contacto">contactarnos</Link>. Nuestro equipo de soporte técnico está disponible para ayudarte a solucionar cualquier problema que puedas tener.</>,
            },
        ],
    },
    {
        id: 'fibra',
        titulo: 'Fibra óptica',
        icono: 'fas fa-network-wired',
        preguntas: [
            {
                pregunta: '¿Qué es la fibra óptica?',
                respuesta: <>La fibra óptica es una tecnología de transmisión de datos en la que se incrementa la velocidad de transferencia. Imagina un hilo delgado y transparente, hecho de vidrio o plástico, por donde viaja tu internet.</>,
            },
            {
                pregunta: '¿Qué es la velocidad simétrica?',
                respuesta: <>La velocidad simétrica se refiere a que tu paquete contará con la misma velocidad de subida y de bajada ofertada. Si tienes contratado un paquete de internet por fibra óptica y deseas velocidades simétricas, puede modificar tu paquete pagando $50.00 adicionales al costo de tu mensualidad.</>,
            },
            {
                pregunta: '¿La fibra óptica es mejor que el internet por antenas?',
                respuesta: <>Pese a que el internet inalámbrico que se presta por medio de antena cuenta con diversos beneficios, la conexión a través de fibra óptica permite una mayor velocidad en la transferencia y en rendimiento y se disminuyen las interferencias. La fibra óptica también permite velocidades de subida y bajada ofertadas simétricas.</>,
            },
            {
                pregunta: '¿La fibra óptica es resistente al mal tiempo?',
                respuesta: <>Sí, es uno de los beneficios de la fibra óptica, su resistencia a diversas condiciones climáticas. Regularmente la lluvia y tormentas eléctricas no afectan la conexión mediante fibra óptica.</>,
            },
            {
                pregunta: '¿Cómo se instala la fibra óptica?',
                respuesta: <>Un técnico especializado de <b>Red Itmex</b> se encargará de llevar a cabo la instalación. El cable de fibra óptica llegará hasta tu casa y se conectará a un dispositivo llamado ONT/Modem. De ahí podrás disfrutar de una conexión. No te preocupes, nuestro equipo te explicará todo durante la instalación.</>,
            },
            {
                pregunta: '¿La fibra óptica funciona con todos los dispositivos?',
                respuesta: <>¡Sí! Puedes conectar cualquier dispositivo que tenga capacidad para conectarse a internet, como smartphones, tablets, ordenadores, consolas de videojuegos y más.</>,
            },
        ],
    },
];

// Datos estructurados FAQPage para Google (la respuesta en texto plano, sin etiquetas)
const textoPlano = (jsx) => renderToStaticMarkup(<StaticRouter>{jsx}</StaticRouter>)
    .replace(/<[^>]+>/g, '')
    .replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&amp;/g, '&');

const FAQ_JSONLD = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: CATEGORIAS.flatMap(c => c.preguntas).map(p => ({
        '@type': 'Question',
        name: p.pregunta,
        acceptedAnswer: { '@type': 'Answer', text: textoPlano(p.respuesta) },
    })),
});

const normalizar = (texto = '') => texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

class PreguntasFrecuentesInternet extends React.Component {
    state = { categoria: 'todas', busqueda: '', abierta: null };

    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }

    render() {
        const { categoria, busqueda, abierta } = this.state;
        const q = normalizar(busqueda.trim());
        const grupos = CATEGORIAS
            .filter(c => categoria === 'todas' || c.id === categoria)
            .map(c => ({ ...c, preguntas: c.preguntas.filter(p => !q || normalizar(p.pregunta).includes(q)) }))
            .filter(c => c.preguntas.length > 0);

        return (
            <div>
                <Helmet>
                    <script type="application/ld+json">{FAQ_JSONLD}</script>
                </Helmet>
                <Layout title="Red Itmex - Preguntas Frecuentes">
                    <section className="faqItmex">
                        <aside className="faqItmex-lateral">
                            <span className="planesItmex-eyebrow">Ayuda</span>
                            <h1 className="tituloItmex tituloItmex--chico">Preguntas frecuentes</h1>
                            <p className="faqItmex-subtitulo">Pagos, contratación, soporte y fibra óptica.</p>

                            <div className="coberturaBuscador faqItmex-buscador">
                                <i className="fas fa-search"></i>
                                <input
                                    type="search"
                                    placeholder="Busca tu pregunta"
                                    aria-label="Buscar pregunta"
                                    value={busqueda}
                                    onChange={e => this.setState({ busqueda: e.target.value })}
                                />
                            </div>

                            <nav className="faqItmex-categorias" aria-label="Categorías">
                                {[{ id: 'todas', titulo: 'Todas', icono: 'fas fa-th-large' }, ...CATEGORIAS].map(c => (
                                    <button key={c.id} type="button" aria-pressed={categoria === c.id}
                                        className={'faqItmex-categoria' + (categoria === c.id ? ' is-activa' : '')}
                                        onClick={() => this.setState({ categoria: c.id })}>
                                        <i className={c.icono}></i>{c.titulo}
                                    </button>
                                ))}
                            </nav>

                            <div className="faqItmex-contacto">
                                <b>¿No encuentras tu respuesta?</b>
                                <span>Escríbenos y te ayudamos.</span>
                                <div className="planesItmex-panel-acciones">
                                    <Link className="heroItmex-cta planesItmex-panel-cta" to="/contacto">
                                        Contáctanos
                                        <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                                    </Link>
                                    <a className="planesItmex-panel-whatsapp" href={WHATSAPP_DUDAS} target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-whatsapp"></i> WhatsApp
                                    </a>
                                </div>
                            </div>
                        </aside>

                        <div className="faqItmex-lista">
                            {grupos.map(grupo => (
                                <div key={grupo.id} className="faqItmex-grupo">
                                    <h2 className="promosItmex-grupo-titulo"><i className={grupo.icono}></i>{grupo.titulo}</h2>
                                    {grupo.preguntas.map(p => {
                                        const abiertaAqui = abierta === p.pregunta;
                                        return (
                                            <div key={p.pregunta} className={'faqItmex-item' + (abiertaAqui ? ' is-abierto' : '')}>
                                                <button type="button" className="faqItmex-pregunta" aria-expanded={abiertaAqui}
                                                    onClick={() => this.setState({ abierta: abiertaAqui ? null : p.pregunta })}>
                                                    <span>{p.pregunta}</span>
                                                    <span className="coberturaMunicipio-toggle"><i className="fas fa-plus"></i></span>
                                                </button>
                                                <div className="coberturaMunicipio-cuerpo" aria-hidden={!abiertaAqui}>
                                                    <div className="coberturaMunicipio-cuerpo-interior">
                                                        <p className="faqItmex-respuesta">{p.respuesta}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ))}
                            {grupos.length === 0 && (
                                <p className="coberturaSinResultados">No encontramos preguntas con “{busqueda}”. Escríbenos y con gusto te ayudamos.</p>
                            )}
                        </div>
                    </section>
                </Layout>
            </div>
        )
    }
};
export default PreguntasFrecuentesInternet;
